import { Injectable, signal } from '@angular/core';
import { SiteSettingsService, BrandingSettings } from './site-setting.service';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class SiteBrandingService {
  private readonly fallback = 'assets/logos/logo.png';
  readonly logoUrl = signal(this.fallback);
  readonly settings = signal<BrandingSettings | null>(null);
  readonly loadFailed = signal(false);

  constructor(private readonly siteSettings: SiteSettingsService) { this.load(); }

  load(): void {
    this.loadFailed.set(false);
    this.siteSettings.getBranding().subscribe({
      next: settings => this.apply(settings),
      error: () => this.loadFailed.set(true),
    });
  }

  apply(settings: BrandingSettings): void {
    this.settings.set(settings);
    this.loadFailed.set(false);
    this.logoUrl.set(settings.logoImageId ? `${environment.apiUrl}/media/${settings.logoImageId}` : this.fallback);
  }
}
